<wbo-edit-grid [data]="model.data[fieldName]" [editable]="true" [removable]="true" [entityPath]="fieldName" [title]="'wbo.report.product-selection.title'">
    <wbo-text-column field="name" [title]="'wbo.report.product-selection.column.name'"></wbo-text-column>
    <wbo-numeric-column field="price" [title]="'wbo.report.product-selection.column.price'"></wbo-numeric-column>
    <wbo-text-column field="categoryName" [title]="'wbo.report.product-selection.column.categoryName'"></wbo-text-column>
    <wbo-edit-grid-add-row [customAdd]="true">
        <wbo-edit-grid-add-row-quick-add (onSelect)="addFromSellable([$event])">
            <wbo-sellable-single-select-edit-control></wbo-sellable-single-select-edit-control>
        </wbo-edit-grid-add-row-quick-add>
        <wbo-edit-grid-add-row-actions>
            <wbo-edit-grid-add-row-search [searchComponent]="SellableSearchPageComponent" (onSelect)="addFromSellable($event)"></wbo-edit-grid-add-row-search>
        </wbo-edit-grid-add-row-actions>
    </wbo-edit-grid-add-row>
</wbo-edit-grid>
